import styled from '@emotion/styled';
import React from 'react';

import { font } from '../Font/Font.styles';

type Props = HeadingProps & {
  level: HeadingLevel;
};

export type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5';

type HeadingProps = {
  desktopSize?:
    | 'micro'
    | 'small'
    | 'smallGoose'
    | 'xxs'
    | 'xs'
    | 'md'
    | 'lg'
    | 'xl';
  mobileSize:
    | 'micro'
    | 'small'
    | 'smallGoose'
    | 'xxs'
    | 'xs'
    | 'md'
    | 'lg'
    | 'xl';
  children?: React.ReactNode;
  noTopMargin?: boolean;
  noBottomMargin?: boolean;
} & React.HTMLAttributes<HTMLHeadingElement>;

const sizeToFontVar = {
  micro: 'body-md-bold',
  small: 'body-lg-bold',
  smallGoose: 'body-lg-bold-goose',
  xxs: 'heading-5',
  xs: 'heading-4',
  md: 'heading-3',
  lg: 'heading-2',
  xl: 'heading-1',
} as const;

// The 'h1' will get overriden with `StyledHeading.withComponent(level)`
const StyledHeading = styled('h1', {
  shouldForwardProp: (prop) =>
    !['desktopSize', 'mobileSize', 'noBottomMargin', 'noTopMargin'].includes(
      prop
    ),
})<HeadingProps>`
  margin-top: ${(props) => (props.noTopMargin ? '0 !important' : undefined)};
  margin-bottom: ${(props) =>
    props.noBottomMargin ? '0 !important' : undefined};
  ${(props) => font(sizeToFontVar[props.mobileSize])};
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  text-wrap: balance;

  @media (min-width: 900px) {
    ${(props) => font(sizeToFontVar[props.desktopSize ?? props.mobileSize])};
  }
  scroll-margin-top: var(--spacing-48);
`;

export const Heading: React.FC<Props> = ({ level, children, ...props }) => {
  const Component = StyledHeading.withComponent(level);
  return <Component {...props}>{children}</Component>;
};
